import Button from './button';

export default class Danger extends Button {
  get buttonClass() {
    return 'ds-button--danger';
  }
}
